import React from 'react';
import {TextField} from "@material-ui/core";
import {Autocomplete} from '@material-ui/lab';

//css
import StylesCss from './styles';
const useStyles = StylesCss();

export default (props) => {
    const classes = useStyles();
    return (
        <div style={{width:"30%",marginLeft: "20px"}}>
            <Autocomplete
                id="lb_id_adminFilter"
                styles={classes.textField}
                options={props.state.fornecedores}
                getOptionLabel={o => o.ID_PESSOA+' - '+o.NM_PESSOA}
                onChange={props.handleChangeSelectFornecedores}
                loadingText={"Carregando..."}
                renderInput={params => (
                    <TextField
                        {...params}
                        variant={"standard"}
                        label={"Selecione o fornecedor"}
                        placeholder={"Fornecedor Lta."}
                        fullWidth
                    />
                )}
            />
        </div>
    );
};